import { render, staticRenderFns } from "./DepartmentComboBoxSelector.vue?vue&type=template&id=53176700&scoped=true&"
import script from "./DepartmentComboBoxSelector.vue?vue&type=script&lang=ts&"
export * from "./DepartmentComboBoxSelector.vue?vue&type=script&lang=ts&"
import style0 from "./DepartmentComboBoxSelector.vue?vue&type=style&index=0&id=53176700&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53176700",
  null
  
)

export default component.exports